import { rightPartyContact } from "api/accounts";
class RpcRepository {
    /**
     * Submits authorized person referral with provided info
     *
     * @method referAuthorized
     * @param {Object} referral Information to send with request
     * @returns {axios.Promise}
     */
    referAuthorized(referral) {
        return rightPartyContact(referral).then(({ data }) => data);
    }
}
export default new RpcRepository();



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/rpc/RpcRepository.ts